import React from 'react';
import FreelancerUserSearchParams from './FreelancerUserSearchParams';
import FreelancerUserService from '../../../Services/FreelancerUserService';
import FreelancerUserItem from '../../../Domain/FreelancerUserItem';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import AddNewFreelancerFeeWindowDescription from './AddNewFreelancerFeeWindowDescription';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import FreelancerLineItemWindowDescription from '../FreelancerLineItem/FreelancerLineItemWindowDescription';
import FreelancerInvoiceService from '../../../Services/FreelancerInvoiceService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ShowTipaltiEvaluatorDataWindow from '../../Evaluator/EvaluatorAdmin/ShowTipaltiEvaluatorDataWindow';
import stringHelper from '../../../Helpers/stringHelper';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import AddIgnoredSurveyWindowDescription from './AddIgnoredSurveyWindowDescription';
import FreelancerUserIgnoredSurveyData from '../../../Domain/FreelancerUserIgnoredSurveyData';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import EditFreelancerUserWindowDescription from './EditFreelancerUserWindowDescription';
import EditFreelancerUserHelper from './EditFreelancerUserHelper';
import FreelancerUserEditItem from '../../../Domain/FreelancerUserEditItem';
import AuthService from '../../../Services/authService';
import UserService from '../../../Services/userService';

class FreelancerUserAdmin extends React.Component {
  constructor(props) {
    super(props);

    const searchItem = new FreelancerUserSearchParams();
    if (props.freelancerUserId > 0) {
      searchItem.FreelanceUserId = props.freelancerUserId.toString();
      searchItem.OfficeName = '';
    }

    this.startSearch = this.startSearch.bind(this);
    this.editFunction = this.editFunction.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    FreelancerUserItem.editFunction = (id, user, userList) => this.editFunction(id, user, userList);
    FreelancerUserItem.addNewFeeFunction = (id, user, userList) => this.addNewFeeFunction(id, user, userList);
    FreelancerUserItem.addNewLineItemFunction = (id, user, userList) => this.addNewLineItemFunction(id, user, userList);
    FreelancerUserItem.addNewInvoiceFunction = this.addNewInvoiceFunction.bind(this);
    FreelancerUserItem.addIgnoredSurveyFunction = this.addIgnoredSurveyFunction.bind(this);

    this.state = {
      userList: [],
      loading: true,
      selected: -1,
      selectedUser: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Asc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel:
        props.freelancerUserId > 0 || !this.isThereAnySearchParameter(searchItem)
          ? ShownPanelsEnum.None
          : ShownPanelsEnum.Search,
      searchItem,
      shownOverWindow: ShownOverWindowsEnum.None,
      popup: null,
    };
    this.showPanel = this.showPanel.bind(this);
    FreelancerUserItem.clickOnPIEvaluatorSassieId = this.clickOnPIEvaluatorSassieId.bind(this);
    FreelancerUserItem.clickOnTpEvaluatorId = this.clickOnPITpEvaluatorId.bind(this);
  }

  editFunction(id, user, userList) {
    const message =
      OfficeHelper.IsEUOffice(user.OfficeId) &&
        user.PaymentMethod === 'Wise' &&
        user.PIPaypalWiseWesternUnionEmail !== ''
        ? `Please remind the vendor to link Bank details to this email (${user.PIPaypalWiseWesternUnionEmail}) address in WISE’s system, otherwise the payment will fail.`
        : '';
    if (message !== '') {
      ErrorMessage.SetWarning(message);
    }

    const editedUser = { ...user };
    editedUser.PaymentMethod = EditFreelancerUserHelper.checkPaymentMethodDoesExistForThisOffice(editedUser);

    // alert("Edit in fee")
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: id,
      selectedUser: editedUser,
    });
  }

  addNewFeeFunction(id, user, userList) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.AddNewFee,
      shownPanel: ShownPanelsEnum.None,
      selected: id,
      selectedUser: user,
      selectedFeeItem: AddNewFreelancerFeeWindowDescription.buildItemForUser(user),
    });
  }

  addNewLineItemFunction(id, user, userList) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.AddNewLineItem,
      shownPanel: ShownPanelsEnum.None,
      selected: id,
      selectedUser: user,
      selectedLineItem: FreelancerLineItemWindowDescription.buildItemForUser(user),
    });
  }

  clickOnPIEvaluatorSassieId(item) {
    this.setState({
      popup: (
        <ShowTipaltiEvaluatorDataWindow
          evaluator={{
            TpEvaluatorId: item.PitpEvaluatorId,
            EvSassieId: item.PIEvaluatorSassieId,
            TipaltiId: item.TipaltiId,
            Name: (item.LastName ?? '') + ', ' + (item.FirstName ?? ''),
          }}
          clickOnCancel={() => this.setState({ popup: null })}
        />
      ),
    });
  }

  clickOnPITpEvaluatorId(item) {
    this.setState({
      popup: (
        <ShowTipaltiEvaluatorDataWindow
          evaluator={{
            TpEvaluatorId: item.PitpEvaluatorId,
            EvSassieId: item.PIEvaluatorSassieId,
            TipaltiId: item.TipaltiId,
            Name: (item.LastName ?? '') + ', ' + (item.FirstName ?? ''),
          }}
          clickOnCancel={() => this.setState({ popup: null })}
        />
      ),
    });
  }

  addNewInvoiceFunction(id, user, userList) {
    const text =
      user.NumberOfCreatedInvoices === 0
        ? `<span>
          You will create an invoice for the following Vendor: <br />
          ${user.FirstName} ${user.LastName} <br />
          The actual line items (if there is any) will be attached.
        </span>`
        : '<span>You will attach the actual line items (if there is any) to the current invoice.</span>';

    ErrorMessage.SetApprove(text, () => this.clickOnAddNewInvoiceButtonInPopup(id, user));
  }

  clickOnAddNewInvoiceButtonInPopup(id, user) {
    FreelancerInvoiceService.CreateFreelancerInvoice(user.FreelancerUserId)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        const message = `${stringHelper.plural(
          result.numberOfLineItems,
          'line item',
          'line items',
          true,
          true
        )} been attached to an invoice.`;
        ErrorMessage.SetNotification(message);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('FUA140');
      });
  }

  addIgnoredSurveyFunction(id, user) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.AddIgnoredSurvey,
      shownPanel: ShownPanelsEnum.None,
      selected: id,
      selectedUser: new FreelancerUserIgnoredSurveyData(user),
    });
  }

  isThereAnySearchParameter(searchItem) {
    for (const key in searchItem) {
      if (searchItem[key]) {
        return true;
      }
    }
    return false;
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    }

    if (panelId === ShownPanelsEnum.AddNewItem) {
      ErrorMessage.SetWarning(
        'Completion and upload of the onboarding checklist is mandatory for profile activation! ' +
        'Templates can be found in this link: ' +
        '<a class="secondarylink" target="_blank" href="https://bareint2.sharepoint.com/sites/HR-Central/For%20Managers%20Only/Forms/AllItems.aspx?id=%2Fsites%2FHR%2DCentral%2FFor%20Managers%20Only%2FGlobal%20Contractor%20and%20IC%20Process&viewid=5ff468a0%2D82df%2D4278%2D93f4%2D1582cbd7ac80">LINK</a>'
      );
      this.setState({ shownPanel: panelId, selectedUser: new FreelancerUserEditItem() });
      return;
    }

    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderShowPanelButton(name, panelId) {
    return (
      <input
        className='m-1'
        type='button'
        value={`${this.state.shownPanel === panelId ? 'Hide' : 'Show'} ${name} Panel`}
        onClick={() => {
          this.showPanel(panelId);
        }}
      />
    );
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedUser}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={EditFreelancerUserWindowDescription}
            errorCode='FUS246'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedUser}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={EditFreelancerUserWindowDescription}
            errorCode='FUS261'
          />
        )}
      </div>
    );
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      shownOverWindow: ShownOverWindowsEnum.None,
      loading: refresh,
    });
    if (refresh) {
      this.refresh();
    }
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          colors={[ButtonColorsEnum.Primary]}
          labels={['Create']}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  renderWindows() {
    switch (this.state.shownOverWindow) {
      case ShownOverWindowsEnum.AddNewFee:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedFeeItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => {
              if (this.state.selectedUser) {
                this.state.selectedUser.NumberOfFees++; //Don't remove this line
              }
              this.editPanelOnClose(true);
            }}
            windowDescription={AddNewFreelancerFeeWindowDescription}
            approveBeforeSaveCheck={AddNewFreelancerFeeWindowDescription.startDateUnchanged}
            approveBeforeSaveMessage={AddNewFreelancerFeeWindowDescription.startDateUnchangedMessage}
            errorCode='FUS351'
          />
        );

      case ShownOverWindowsEnum.AddNewLineItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedLineItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => {
              if (this.state.selectedUser) {
                this.state.selectedUser.NumberOfLineItems++; //Don't remove this line
              }
              this.editPanelOnClose(true);
            }}
            windowDescription={FreelancerLineItemWindowDescription}
            errorCode='FUS378'
          />
        );
      case ShownOverWindowsEnum.AddIgnoredSurvey:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedUser}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={AddIgnoredSurveyWindowDescription}
            errorCode='FUS327'
          />
        );
      default:
        break;
    }
  }

  startSearch(searchItem) {
    if (
      AuthService.HasRoleArray(['FinanceAdmin_VendorMgtm', 'VendorInvoicingAdmin_*']) &&
      !AuthService.IsAdmin() &&
      !searchItem?.OfficeName
    ) {
      searchItem = { ...searchItem, OfficeName: UserService.GetOfficeIdOfLoggedInUser() };
    }
    this.setState({
      searchItem: searchItem,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={FreelancerUserItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={FreelancerUserService.GetFreelancerUserList}
          convertDBItemsFunction={FreelancerUserService.ConvertDBFreelancerUser}
          searchItem={this.state.searchItem}
          searchParamsType={FreelancerUserSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          errorCode='FUA353'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in id, name, email or role...'
        />
        {this.renderWindows()}
        {this.state.popup}
      </div>
    );
  }
}

export default FreelancerUserAdmin;
